import { inTauri } from "./tools";

export async function deleteLocalSandbox(chatId: string) {
  if (!inTauri) return;
  const { invoke } = await import("@tauri-apps/api/core");
  await invoke("sandbox_delete", { chatId }).catch((e) => console.warn("Couldn't delete the chat's sandbox:", e));
}

/** Removes sandboxes whose chat no longer exists. Only pass a chat list that loaded successfully. */
export async function pruneLocalSandboxes(liveChatIds: string[]) {
  if (!inTauri) return;
  const { invoke } = await import("@tauri-apps/api/core");
  const removed = await invoke<string[]>("sandbox_prune", { keep: liveChatIds }).catch((e) => {
    console.warn("Couldn't clean up old sandboxes:", e);
    return [];
  });
  if (removed.length) console.info(`Removed sandboxes of deleted chats: ${removed.join(", ")}`);
}
